<template>
  <div>
    <loading v-if="isLoading"></loading>
    <div v-else>
      <div class="container-fluid" id="page-start">
        <div class="row">
          <div
            class="es-xs-12 es-sm-12 es-md-12 es-lg-8 es-xl-8 col-sticky u-top-0"
          >
            <h4 class="u-margin-bottom-none">
              {{ $t("batteries.saveTitle") }}
            </h4>
            <p class="u-margin-bottom u-color-muted">
              <small>
                {{
                  !result
                    ? $t("batteries.firstCalculateBattery")
                    : $t("batteries.saveDescription")
                }}</small
              >
            </p>
            <div class="row u-margin-0">
              <div class="es-xs-12">
                <alert :value="alertBox"></alert>
              </div>
              <div class="es-xs-12 es-sm-6">
                <BatteryFeatureItem
                  class="es-xs-12 es-lg-12 u-margin-top-xxsmall"
                  v-for="(item, i) in features.slice(0, 1)"
                  :key="i"
                  ref="batteryFeatureItem"
                  :form="form"
                  @open="getOptions"
                  :index="i"
                  :isLast="i === features.length - 1"
                  :item="item"
                  :validActivated="validActivated"
                  col="12"
                ></BatteryFeatureItem>
                <BatteryFeatureItem
                  class="es-xs-12 es-lg-12 u-margin-top-xxsmall"
                  v-for="(item, i) in features.slice(2, 3)"
                  :key="i"
                  ref="batteryFeatureItem"
                  :form="form"
                  @open="getOptions"
                  :index="i"
                  :isLast="i === features.length - 1"
                  :item="item"
                  :validActivated="validActivated"
                  col="12"
                ></BatteryFeatureItem>
              </div>
              <div class="es-xs-12 es-sm-6 u-margin-top-small">
                <BatteryFeatureItem
                  class="es-xs-12 es-lg-12 u-margin-top-xxsmall"
                  v-for="(item, i) in features.slice(1, 2)"
                  :key="i"
                  ref="batteryFeatureItem"
                  :form="form"
                  @open="getOptions"
                  :index="i"
                  :isLast="i === features.length - 1"
                  :item="item"
                  :validActivated="validActivated"
                  col="12"
                ></BatteryFeatureItem>
                <!-- <h6 class="u-margin-bottom-none">
                  <strong>
                    <i
                      class="icofont-ui-calculator u-font-size-xsmall u-margin-right-xsmall"
                    ></i>
                    {{ $t("batteries.calculateTitle") }}
                  </strong>
                </h6>
                <p class="u-margin-bottom u-color-muted">
                  <small> {{ $t("batteries.calculateDescription") }}</small>
                </p> -->
                <Button
                  block
                  @click="getResult"
                  variant="secondary"
                  class="u-margin-top"
                >
                  <i class="icofont-check"></i> {{ $t("batteries.calculate") }}
                </Button>
              </div>
            </div>
          </div>
          <div
            id="to-result"
            class="es-xs-12 es-lg-4 es-xl-4 col-sticky u-top-0"
          >
            <div class="u-padding-xsmall">
              <BatteryFeatureItem
                v-for="(item, i) in resultFeatures"
                :key="i"
                :form="form"
                :index="i"
                @open="getOptions"
                :item="item"
                :validActivated="validActivated"
                isResult
                col="12"
              ></BatteryFeatureItem>
            </div>
            <div
              class="u-border u-radius-g u-padding-xsmall u-margin-top-small"
              style="position: sticky; top: 0; z-index: 1000"
            >
              <BaseInput
                v-model="batteryName"
                :label="$t('batteries.name')"
                @input="
                  batteryName = $event;
                  changedItemInFeatures = true;
                "
                :mandotary="result ? true : false"
                block
                :placeholder="$t('batteries.namePlaceholder')"
              ></BaseInput>
              <Button
                :disabled="!result || !batteryName"
                block
                @click="
                  (e, l) => (edit ? updateBattery(e, l) : createBattery(e, l))
                "
                variant="primary"
              >
                <i class="icofont-save"></i> {{ $t("common.save") }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import { mapGetters } from "vuex";
import BatteryFeatureItem from "./BatteryFeatureItem.vue";
import Button from "@/components/Base/Button.vue";
import { getBatteryRequestBodies } from "@/helpers/Battery/getBatteryType";
import Alert from "@/components/Base/Alert.vue";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
export default {
  components: {
    BaseInput,
    BatteryFeatureItem,
    Button,
    Alert,
  },
  watch: {
    features: {
      deep: true,
      handler() {
        this.changedItemInFeatures = true;
      },
    },
  },
  computed: {
    ...mapGetters(["getBatteryFeatureByFeatureType"]),
    resultFeatures() {
      return this.allFeatures.filter((item) => item.isResult);
    },
    features() {
      return this.allFeatures.filter((item) => !item.isResult);
    },
    changeDetected() {
      return this.changedItemInFeatures && this.result && this.form.id;
    },
  },
  data() {
    return {
      batteryName: "",
      isLoading: true,
      allFeatures: [],
      lazySearchTimeout: -1,
      validActivated: false,
      result: null,
      changedItemInFeatures: false,
      alertBox: {
        status: false,
        text: "",
        variant: "",
      },
    };
  },
  props: {
    form: {
      default: () => ({
        type: "",
      }),
    },
    edit: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    async updateBattery(e, loading) {
      this.validActivated = true;
      const validation = this.$refs.batteryFeatureItem.every((item) => {
        return item.getValidItemsCount().validation;
      });
      if (!validation) {
        this.features.forEach((item) => {
          item.show = false;
        });
        document
          .getElementById("page-start")
          .scrollIntoView({ behavior: "smooth", block: "start" });
        this.alertBox = {
          status: true,
          variant: "danger",
          text: this.$t("batteries.fillAllFeatures"),
        };
        return;
      }
      loading(true);
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
      });
      // create body for request;
      const data = getBatteryRequestBodies(this.form.type, this.features);

      const response = await Requests.Battery.Update(
        {
          ...data.body,
          type: this.form.type,
          name: this.batteryName,
        },
        { params: { id: this.form.id } }
      );

      if (response.message === "OK") {
        this.changedItemInFeatures = false;
        this.$emit("created", {
          id: response.data,
          name: this.batteryName,
          type: this.form.type,
          ...data.body,
        });
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("batteries.success"),
          variant: "success",
          duration: 2500,
        });
        setTimeout(() => {
          // yeniden set et.
          this.$router.push({ name: "batteries" });
        }, 250);
      } else if (response.exceptionMessage) {
        this.showAlertBox(response.exceptionMessage);
      } else {
        this.showAlertBox(this.$t(`message.${response.message}.description`));
      }
      loading(false);
    },
    async createBattery(e, loading) {
      this.validActivated = true;
      const validation = this.$refs.batteryFeatureItem.every((item) => {
        return item.getValidItemsCount().validation;
      });
      if (!validation) {
        this.features.forEach((item) => {
          item.show = false;
        });
        document
          .getElementById("page-start")
          .scrollIntoView({ behavior: "smooth", block: "start" });
        this.alertBox = {
          status: true,
          variant: "danger",
          text: this.$t("batteries.fillAllFeatures"),
        };
        return;
      }
      loading(true);
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
      });
      // create body for request;
      const data = getBatteryRequestBodies(this.form.type, this.features);

      const response = await Requests.Battery.Create({
        ...data.body,
        type: this.form.type,
        name: this.batteryName,
      });

      if (response.message === "OK") {
        this.changedItemInFeatures = false;
        this.$emit("created", {
          id: response.data,
          name: this.batteryName,
          type: this.form.type,
          ...data.body,
        });
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("batteries.success"),
          variant: "success",
          duration: 2500,
        });
        setTimeout(() => {
          // yeniden set et.
          this.$router.push({ name: "batteries" });
        }, 250);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
        if (response.exceptionMessage) {
          this.showAlertBox(response.exceptionMessage);
        } else {
          this.showAlertBox(this.$t(`message.${response.message}.description`));
        }
      }
      loading(false);
    },
    setBatteryResultToResultFeatures(result) {
      const resultFeatures = this.allFeatures.filter((item) => item.isResult);

      for (const key in result) {
        if (Object.prototype.hasOwnProperty.call(result, key)) {
          const element = result[key];

          resultFeatures.forEach((item) => {
            item.options.forEach((option) => {
              if (option.bodyKey === key) option.value = element;
            });
          });
        }
      }
    },
    async getResult(e, loading) {
      this.validActivated = true;
      const validation = this.$refs.batteryFeatureItem.every((item) => {
        return item.getValidItemsCount().validation;
      });
      if (!validation) {
        this.features.forEach((item) => {
          item.show = false;
        });
        this.showAlertBox(this.$t("batteries.fillAllFeatures"));
        return;
      }
      loading(true);
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("batteries.calculating"),
      });
      // create body for request;
      const body = getBatteryRequestBodies(this.form.type, this.features);

      const response = await body.calculateRequest({
        ...body.body,
        type: this.form.type,
        name: this.batteryName,
      });
      if (response.message === "OK") {
        this.result = response.data;
        this.setBatteryResultToResultFeatures(response.data);
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
        document
          .getElementById("to-result")
          .scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: response.exceptionMessage,
          variant: "danger",
          duration: 5 * 1000,
        });
        this.showAlertBox(response.exceptionMessage);
      }
      loading(false);
    },
    showAlertBox(text, variant = "danger") {
      this.alertBox = {
        status: true,
        variant: variant,
        text: text,
      };
      document
        .getElementById("page-start")
        .scrollIntoView({ behavior: "smooth", block: "start" });
    },
    async getOptions(option, search, loading) {
      loading(true);
      await this.$store.dispatch("getBatteryFeatures", {
        ...option.requestKey,
        batteryType: this.form.type,
      });
      loading(false);
    },
    async getFeatures(battery) {
      this.isLoading = true;
      const response = await Requests.BatteryFeatures.GetAll({
        query: { batteryType: battery.type },
      });
      if (response.message === "OK") {
        this.allFeatures = response.data.map((item) => ({
          ...item,
          options: item.options.map((option) => {
            if (battery.id) {
              this.batteryName = battery.name;
              const section = battery[item.bodyKey] || {};
              const hasBodyValue = section[option.bodyValue] ? true : false;

              const value = hasBodyValue
                ? {
                    title: section[option.bodyValue],
                    id: section[option.bodyKey],
                  }
                : section[option.bodyValue] || section[option.bodyKey] || null;
              return {
                ...option,
                value: value,
              };
            } else {
              return {
                ...option,
                value: null,
              };
            }
          }),
          show: true,
        }));
      }

      this.isLoading = false;
    },
  },
  mounted() {
    this.getFeatures(this.form);
  },
};
</script>

<style></style>
